import { ChangeDetectionStrategy, Component, HostBinding, computed, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { TagComponent } from '@pedix-workspace/angular-ui-alert';
import { CurrencyFormatPipe, PriceDiscountPipe } from '@pedix-workspace/pedixapp-shared-pipes';
import clsx from 'clsx';

export type ProductDetailItemType = 'product-detail' | 'option-item';

/**
 * Price display for the PDP main price and the option-item selectors.
 * Replaces the legacy `<pxw-product-price>` `product-detail` + `option-item` layouts.
 * Renders struck + sale + the raw `%` of the priceDiscount (this surface is the only one
 * where the raw % shows next to its context — promo mechanics go in <pxw-product-details-promotion-tags>).
 */
@Component({
  selector: 'pxw-product-detail-item-price',
  templateUrl: './product-detail-item-price.component.html',
  styleUrls: ['./product-detail-item-price.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, TagComponent, CurrencyFormatPipe, PriceDiscountPipe],
})
export class ProductDetailItemPriceComponent {
  itemType = input.required<ProductDetailItemType>();
  price = input.required<number>();
  priceDiscount = input<number>();
  displayProductPriceWithoutTaxes = input<boolean>(false);

  hasPriceDiscount = computed(() => {
    const discount = this.priceDiscount();
    return !!discount && discount < this.price();
  });

  currentPrice = computed(() => this.priceDiscount() ?? this.price());

  priceWithoutTaxes = computed(() => Math.round((this.currentPrice() * 100) / 121));

  @HostBinding('class')
  get classNames() {
    return clsx(`type-${this.itemType()}`, {
      'with-discount': this.hasPriceDiscount(),
      'without-taxes': this.displayProductPriceWithoutTaxes(),
    });
  }
}
